import { Box, Grid } from '@mui/material';
import {
  StyledDescription,
  StyledSection,
  StyledTitle,
} from '../AiKnowledgeManagementSolutions.styles';
import {
  InstantKnowledgeWrapper,
  InstantKnowledgeTitle,
} from './InstantKnowledge.styles';
import { instantKnowledgeData } from './InstantKnowledge.data';
import Image from 'next/image';

export const InstantKnowledge = () => {
  return (
    <StyledSection width="small">
      <StyledTitle variant="display_sm">
        Instant Knowledge for Every Department
      </StyledTitle>
      <StyledDescription
        variant="regular_500"
        display="inline-block"
        textAlign="center"
        width="100%">
        See where our AI-powered solution brings measurable results
      </StyledDescription>

      <Grid container spacing={2} mt={4} alignItems="stretch">
        {instantKnowledgeData.map(({ title, description, icon }, index) => (
          <Grid key={`instantKnowledge-${index}`} size={{ xs: 12, md: 6 }}>
            <InstantKnowledgeWrapper>
              <Image src={icon} alt={title} width={32} height={32} />
              <Box>
                <InstantKnowledgeTitle variant="regular_400">
                  {title}
                </InstantKnowledgeTitle>
                <StyledDescription>{description}</StyledDescription>
              </Box>
            </InstantKnowledgeWrapper>
          </Grid>
        ))}
      </Grid>
    </StyledSection>
  );
};
